import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import user_account_api from "../../api/user-account-api";

interface ModalProps {
    displayDevKeyModal: () => void;
    onClose: () => void;
}


interface State {
    devKey: any;
}

class ModalConfirmDevKey extends Component<ModalProps, State> {
    constructor(props: ModalProps) {
        super(props);
    }

    render() {

        let styles = {
            width: 'auto',
        }

        return ReactDOM.createPortal(
            <div onClick={() => this.props.onClose()}
                style={{ display: 'block', paddingLeft: '12px' }}
                className="modal fade in"
                role="dialog"
                aria-labelledby="api-key"
                id="api-key">

                <div onClick={(e) => e.stopPropagation()} className="modal-dialog modal-sm" role="document">
                    <div className="modal-content">

                        <div className="modal-header">
                            <button onClick={() => this.props.onClose()} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <i className="fa fa-close"></i>
                            </button>
                            <h4 className="modal-title text-white text-capitalize">Confirm New API Key</h4>
                        </div>


                        <div className="modal-body">
                            <div className="modal-confirm">
                                <p>
                                    Are you sure you would like to generate a new API key? This will deactivate any existing API keys in use.
                                </p>
                                <br></br>
                                <div className="buttons">
                                    <button
                                        style={styles}
                                        onClick={() => this.props.displayDevKeyModal()}
                                        className="btn btn-purple btn-sm"
                                    >
                                        Continue
                                    </button>
                                    <button
                                        style={styles}
                                        onClick={() => this.props.onClose()}
                                        className="btn btn-light btn-sm"
                                        aria-label="Close"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>,
            document.body
        );
    };
}
export default ModalConfirmDevKey;
